import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { EvolutiescoreTable } from './EvolutiescoreTable';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { InfoPanel } from '../../InfoPanel/InfoPanel';
import { DownloadButton } from '../../DownloadButton/DownloadButton';
import { BarChartDelta, BarChartComparisson } from '../../BarChart/BarChart';

export const Evolutiescore = (props: any) => {
  const { data, clickHandler, allIndicators, interactieveToolPath } = props;
  const {
    tableWidth,
    interfaceColor,
    radarColors,
    selectedGemeente,
    selectedBenchmarks,
    selectedTopic,
    locale,
    deltaColors,
  } = useData();

  const id = 'evolutieScoreSurvey';

  const [keysInStack, setKeysInStack] = useState([
    'valueReal',
    'valueRealVorig',
  ]);

  const [colorsBar, setColorsBar] = useState(radarColors);

  return (
    <Grid container style={{ padding: '16px' }}>
      <Grid item xs={12}>
        <div
          className={'vl-typography'}
          style={{ paddingLeft: '8rem', float: 'left', width: '70%' }}
        >
          <h4 className="page-title">
            Hoe evolueert {selectedGemeente.label} ten opzichte van de
            burgerbevraging {data.length > 0 && data[0].jaarVorig}?{' '}
            <Tooltip>
              <TooltipTrigger
                style={{
                  width: '30px',
                  top: '4px',
                  position: 'relative',
                  display: 'inline',
                }}
              >
                <MdHelpOutline
                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: interfaceColor,
                  }}
                />
              </TooltipTrigger>
              <TooltipContent className="Tooltip">
                <p>
                  In de linkse grafiek tonen we per indicator het percentage van{' '}
                  {data.length > 0 && data[0].jaar} en{' '}
                  {data.length > 0 && data[0].jaarVorig}.
                </p>

                <p>
                  In de rechtse grafiek brengen we het absoluut verschil
                  uitgedrukt in procentpunten in beeld.
                </p>

                <p>
                  De indicatoren zijn gerangschikt van sterkste stijger tot
                  sterkste daler.
                </p>
                <br />

                <p>
                  In de interactieve toepassing vind je alle surveyindicatoren
                  terug per thema.
                </p>

                <p>
                  Via de knop 'Meer informatie' kan je per indicator meteen naar
                  de interactieve toepassing gaan.
                </p>

                {/* <p>
                  In de linkse grafiek tonen we per indicator het percentage
                  voor {data.length > 0 && data[0].jaar} en voor{' '}
                  {data.length > 0 && data[0].jaarVorig}.
                </p>
                <br />
                <p>In de tooltip geven we nog twee waarden mee: </p> <br />
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li>
                    Absolute toename/afname: hoeveel procentpunten is{' '}
                    {selectedGemeente.label} gestegen of gedaald ten opzichte
                    van de vorige bevraging? <br />
                    De berekening is als volgt: {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaar}) -{' '}
                    {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaarVorig}).
                  </li>
                  <li>
                    Relatieve toename/afname: hoe sterk is{' '}
                    {selectedGemeente.label}, relatief gezien, gestegen of
                    gedaald in verhouding tot de vorige meting? <br />
                    De berekening is als volgt: ( {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaar}) -{' '}
                    {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaarVorig}) ) /{' '}
                    {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaarVorig}).
                  </li>
                </ul>
                <br />
                <p>
                  In de rechtse grafiek brengen we de relatieve toename/afname
                  in beeld. Dit laat toe om de toename/afname over indicatoren
                  heen in perspectief te plaatsen. Zo kan je snel over
                  indicatoren heen vergelijken.
                </p>{' '}
                <br />
                <p>
                  De indicatoren zijn gesorteerd van grootste toename naar
                  grootste afname.
                </p> */}
              </TooltipContent>
            </Tooltip>
          </h4>
          <p className="page-subtitle">
            Welke indicatoren uit de kernset voor het thema{' '}
            {selectedTopic.thema} kennen een afname of toename ten opzichte van
            de resultaten uit de burgerbevraging{' '}
            {data.length > 0 && data[0].jaarVorig}?
          </p>
        </div>
        <div
          className={'vl-typography'}
          style={{
            float: 'right',
            // marginLeft: 'auto',
            marginRight: '36px',
            cursor: 'pointer',
            paddingRight: '8px',
            paddingLeft: '8px',
            backgroundColor: interfaceColor,
            borderRadius: 12,
            position: 'relative',
            top: '18px',
          }}
        >
          <p onClick={clickHandler} style={{ marginBottom: 0, color: 'white' }}>
            Pas je selectie aan
          </p>
        </div>

        {data !== undefined && data.length > 0 && (
          <DownloadButton id={id} name={`${id}_${selectedTopic.thema}`} />
        )}

        <InfoPanel
          allIndicators={allIndicators}
          data={data}
          interactieveToolPath={interactieveToolPath}
        />
      </Grid>

      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'80vh'}
        minHeight={'400px'}
        maxHeight={'80vh'}
        id={id}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        {data !== undefined && data.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={8}
              sx={{ height: data.length * 52 + 86, maxHeight: '66vh' }}
            >
              <h5 style={{ textAlign: 'center' }}>
                <span style={{ color: colorsBar[0] }}>{data[0].jaar}</span>{' '}
                versus{' '}
                <span style={{ color: colorsBar[1] }}>{data[0].jaarVorig}</span>
              </h5>
              <BarChartComparisson
                data={data}
                keysInStack={keysInStack}
                colors={colorsBar}
                locale={locale}
                survey={data?.detail?.survey === '0' ? false : true}
                legend={false}
                labels={[data[0].jaar, data[0].jaarVorig]}
              />
            </Grid>
            <Grid
              item
              xs={4}
              sx={{ height: data.length * 52 + 86, maxHeight: '66vh' }}
            >
              <h5 style={{ textAlign: 'center' }}>
                <span style={{ color: deltaColors[1] }}>Afname</span> of{' '}
                <span style={{ color: deltaColors[0] }}>toename</span> t.o.v.{' '}
                {data.length > 0 && data[0].jaarVorig}
              </h5>
              <BarChartDelta data={data} colors={deltaColors} locale={locale} />
            </Grid>
          </Grid>
        ) : (
          <p>Geen data gevonden</p>
        )}
      </Grid>
    </Grid>
  );
};
